import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/fithor_round_border.svg'
import _imports_1 from '@/assets/images/fithor_logotype.svg'
import _imports_2 from '@/assets/images/appstore.svg'
import _imports_3 from '@/assets/images/google_play.svg'
import _imports_4 from '@/assets/images/review_note.svg'
import _imports_5 from '@/assets/images/color_analyzer.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-0cb287c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "main_visual",
  class: "slider_wrapper"
}
const _hoisted_2 = {
  class: "slide slide3",
  key: 0
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slide_inner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "slide_title" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "fithor_icon",
      src: _imports_0,
      alt: "Fithor"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "fithor_logotype",
      src: _imports_1
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "筋トレの記録やスケジュールを管理する"),
  /*#__PURE__*/_createElementVNode("ul", { class: "store" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://apps.apple.com/jp/app/fithor/id1524260548",
        class: "store_apple"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_2,
          alt: "app store"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://play.google.com/store/apps/details?id=jp.kamusoft.hathor",
        class: "store_google"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_3,
          alt: "google play"
        })
      ])
    ])
  ])
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  class: "slide slide1",
  key: 1
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slide_inner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "slide_title" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }),
    /*#__PURE__*/_createElementVNode("span", null, "復習帳")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("学習内容を忘れないように"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("効率の良い復習をサポート")
  ]),
  /*#__PURE__*/_createElementVNode("ul", { class: "store" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://itunes.apple.com/jp/app/%E5%BE%A9%E7%BF%92%E5%B8%B3-%E5%BF%98%E3%82%8C%E3%82%8B%E5%89%8D%E3%81%AB%E5%BE%A9%E7%BF%92%E3%82%92%E9%80%9A%E7%9F%A5%E3%81%97%E3%81%A6%E5%8A%B9%E7%8E%87%E3%81%AE%E3%82%88%E3%81%84%E5%8B%89%E5%BC%B7%E3%82%92%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88/id1219259567?mt=8",
        class: "store_apple"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_2,
          alt: "app store"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://play.google.com/store/apps/details?id=jp.kamusoft.reviewnote",
        class: "store_google"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_3,
          alt: "google play"
        })
      ])
    ])
  ])
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  class: "slide slide2",
  key: 2
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slide_inner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "slide_title" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }),
    /*#__PURE__*/_createElementVNode("span", null, "色しらべ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("カメラで日常の色を調べる"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("ul", { class: "store" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://itunes.apple.com/jp/app/%E8%89%B2%E3%81%97%E3%82%89%E3%81%B9-%E3%82%AB%E3%83%A1%E3%83%A9%E3%81%A7%E8%89%B2%E3%81%AE%E6%83%85%E5%A0%B1%E3%82%92%E6%8A%BD%E5%87%BA-%E9%85%8D%E8%89%B2%E3%81%AE%E8%A7%A3%E6%9E%90/id1160206848?mt=8",
        class: "store_apple"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_2,
          alt: "app store"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://play.google.com/store/apps/details?id=jp.kamusoft.coloranalyzer",
        class: "store_google"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_3,
          alt: "google play"
        })
      ])
    ])
  ])
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { id: "slider_ctrl" }
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: _ctx.state.animeMode,
      duration: 500
    }, {
      default: _withCtx(() => [
        (_ctx.state.curPos===0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : (_ctx.state.curPos===1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : (_ctx.state.curPos===2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
              : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["name"]),
    _createElementVNode("div", _hoisted_11, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.positions, (pos) => {
        return (_openBlock(), _createElementBlock("a", {
          key: pos,
          class: _normalizeClass({current:pos===_ctx.state.curPos}),
          onClick: ($event: any) => (_ctx.showItem(pos))
        }, null, 10, _hoisted_12))
      }), 128))
    ])
  ]))
}